(function () {
  'use strict';

  var configuratorRoot = document.querySelector('[data-custom-chopstick-configurator-root]');
  if (
    !configuratorRoot ||
    !configuratorRoot.configuratorApp ||
    !configuratorRoot.configuratorArtwork ||
    !configuratorRoot.configuratorFlatView ||
    !configuratorRoot.productStage ||
    !configuratorRoot.configuratorSampleBrowser
  ) return;
  if (configuratorRoot.getAttribute('data-configurator-presentation-initialized') === 'true') return;

  var PRESENTATIONS = {
    logo: { layout: 'sleeve-primary', product: 'sleeve', flat: false },
    content: { layout: 'sleeve-primary', product: 'sleeve', flat: false },
    details: { layout: 'sleeve-primary', product: 'sleeve', flat: false },
    layouts: { layout: 'sample-browser', product: 'sleeve', flat: false },
    edit: { layout: 'editor', product: 'sleeve', flat: false },
    chopsticks: { layout: 'order-flow', product: 'full', flat: false },
    review: { layout: 'order-flow', product: 'full', flat: false },
    confirmation: { layout: 'order-flow', product: 'full', flat: false }
  };
  var app = configuratorRoot.configuratorApp;
  var artworkApi = configuratorRoot.configuratorArtwork;
  var flatViewApi = configuratorRoot.configuratorFlatView;
  var productStage = configuratorRoot.productStage;
  var sampleBrowser = configuratorRoot.configuratorSampleBrowser;
  var editor = configuratorRoot.configuratorEditor || null;
  var workflowPanel = configuratorRoot.querySelector('[data-custom-chopstick-configurator-app]');
  var orderFlow = configuratorRoot.querySelector('[data-configurator-order-flow]');
  var createIntroduction = configuratorRoot.querySelector('[data-configurator-create-introduction]');
  var entryIntro = configuratorRoot.querySelector('[data-configurator-entry-intro]');
  var entryDesignButton = configuratorRoot.querySelector('[data-configurator-entry-design]');
  var entryActive = configuratorRoot.getAttribute('data-configurator-entry') === 'intro' && Boolean(entryIntro && entryDesignButton);
  if (entryActive && configuratorRoot.getAttribute('data-configurator-draft-restored') === 'true') {
    entryActive = false;
    configuratorRoot.setAttribute('data-configurator-entry', 'workspace');
    entryIntro.hidden = true;
  }
  var entryHideTimer = null;
  var entryEntranceTimer = null;
  var entryEntranceStarted = false;
  var currentPresentation = null;
  var previousStageId = null;
  var unsubscribe = null;
  var unsubscribeArtwork = null;
  var workingDocument = null;
  var introductionDelayTimer = null;
  var introductionFallbackTimer = null;
  var introductionHideTimer = null;
  var introductionActive = false;
  var entranceRunning = false;
  var introductionDismissible = false;
  var destroyed = false;

  configuratorRoot.setAttribute('data-configurator-presentation-initialized', 'true');

  function presentationFor(stageId) {
    return PRESENTATIONS[stageId] || PRESENTATIONS.logo;
  }

  function setRegionActive(region, active) {
    if (!region) return;
    region.setAttribute('aria-hidden', active ? 'false' : 'true');
    if (active) region.removeAttribute('inert');
    else region.setAttribute('inert', '');
  }

  function isMeaningfulCreateAction(action) {
    return Boolean(
      action && typeof action.type === 'string' &&
      (
        action.type === 'workflow:next' ||
        action.type.indexOf('configuration:update') === 0
      )
    );
  }

  function showCreateWorkspace() {
    if (entryActive) return;
    configuratorRoot.setAttribute('data-configurator-create-workspace', 'visible');
    if (!workflowPanel || (currentPresentation && currentPresentation.layout === 'editor')) return;
    setRegionActive(workflowPanel, true);
  }

  function handleArtwork(payload) {
    workingDocument = payload && payload.document ? payload.document : null;
    if (entryActive && !entryEntranceStarted && !entryEntranceTimer) {
      configuratorRoot.setAttribute('data-configurator-entry-product', 'ready');
      configuratorRoot.setAttribute('data-configurator-entry-ripple', 'waiting');
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      entryEntranceTimer = window.setTimeout(beginEntryEntrance, reducedMotion ? 0 : 360);
    }
  }

  function beginEntryEntrance() {
    entryEntranceTimer = null;
    if (!entryActive || entryEntranceStarted || destroyed) return;
    entryEntranceStarted = true;
    configuratorRoot.setAttribute('data-configurator-entry-ripple', 'running');
    var started = productStage.playCreateEntrance && productStage.playCreateEntrance(function () {
      configuratorRoot.setAttribute('data-configurator-entry-ripple', 'settled');
    });
    if (!started) configuratorRoot.setAttribute('data-configurator-entry-ripple', 'settled');
  }

  function renderedSideForSemanticReference(reference) {
    if (!reference || !workingDocument || !workingDocument.sides) return null;
    var matches = [];
    ['front', 'back'].forEach(function (side) {
      var sideData = workingDocument.sides[side];
      var objects = sideData && Array.isArray(sideData.objects) ? sideData.objects : [];
      var hasMatch = objects.some(function (object) {
        if (!object || object.type !== 'text' || !object.content || object.content.kind !== 'semantic') return false;
        var boundReference = object.content.reference;
        return boundReference === reference || (
          reference.indexOf('restaurantInfo.') === 0 && boundReference === 'restaurantInfo'
        );
      });
      if (hasMatch) matches.push(side);
    });
    return matches.length === 1 ? matches[0] : null;
  }

  function showCreateHeading(stageId) {
    if (!createIntroduction) return;
    var visible = configuratorRoot.getAttribute('data-configurator-entry') === 'workspace' &&
      (stageId === 'logo' || stageId === 'content');
    var available = configuratorRoot.getAttribute('data-configurator-capabilities') !== 'dismissed';
    createIntroduction.hidden = !visible;
    createIntroduction.setAttribute('aria-hidden', visible && available ? 'false' : 'true');
    createIntroduction.removeAttribute('data-state');
  }

  function applyPresentation(snapshot, action) {
    if (destroyed) return;
    var stageId = snapshot.workflow.currentStage;
    var meaningfulCreateAction = isMeaningfulCreateAction(action);
    if (meaningfulCreateAction) {
      configuratorRoot.setAttribute('data-configurator-capabilities', 'dismissed');
      if (introductionDismissible) dismissCreateIntroduction(false);
    }
    if (stageId === 'content' && previousStageId !== 'content' && productStage.resetContextualAssist) {
      productStage.resetContextualAssist();
    }
    previousStageId = stageId;
    if (entranceRunning && (meaningfulCreateAction || stageId !== 'logo')) {
      if (productStage.settleEntrance) productStage.settleEntrance();
      completeCreateEntrance();
    }
    var next = presentationFor(stageId);
    showCreateHeading(stageId);
    setRegionActive(workflowPanel, !entryActive && next.layout !== 'editor' && next.layout !== 'order-flow');
    setRegionActive(orderFlow, next.layout === 'order-flow');
    configuratorRoot.setAttribute('data-configurator-presentation-stage', stageId);

    if (
      currentPresentation &&
      currentPresentation.layout === next.layout &&
      currentPresentation.product === next.product &&
      currentPresentation.flat === next.flat
    ) {
      flatViewApi.setWorkspaceActive(next.flat);
      sampleBrowser.setActive(next.layout === 'sample-browser');
      if (editor) editor.setActive(next.layout === 'editor');
      return;
    }

    var hadPresentation = Boolean(currentPresentation);
    currentPresentation = next;
    configuratorRoot.setAttribute('data-configurator-presentation', next.layout);
    configuratorRoot.setAttribute('data-configurator-product-content', next.product);
    productStage.setProductMode(next.product);
    flatViewApi.setWorkspaceActive(next.flat);
    sampleBrowser.setActive(next.layout === 'sample-browser');
    if (editor) editor.setActive(next.layout === 'editor');

    if (next.flat) flatViewApi.syncProductView();
    else if (hadPresentation) productStage.setView('angled');
  }

  function shouldIntroduceCreateStage(snapshot) {
    return Boolean(
      createIntroduction &&
      snapshot.workflow.currentStage === 'logo' &&
      snapshot.workflow.visitedStages.length === 1 &&
      snapshot.workflow.visitedStages[0] === 'logo' &&
      snapshot.workflow.completedStages.length === 0 &&
      configuratorRoot.getAttribute('data-configurator-draft-restored') !== 'true'
    );
  }

  function clearIntroductionTiming() {
    if (introductionDelayTimer) window.clearTimeout(introductionDelayTimer);
    if (introductionFallbackTimer) window.clearTimeout(introductionFallbackTimer);
    if (introductionHideTimer) window.clearTimeout(introductionHideTimer);
    introductionDelayTimer = null;
    introductionFallbackTimer = null;
    introductionHideTimer = null;
  }

  function dismissCreateIntroduction(immediate) {
    if (!introductionActive || !createIntroduction) return;
    introductionActive = false;
    introductionDismissible = false;
    createIntroduction.setAttribute('aria-hidden', 'true');
    createIntroduction.setAttribute('data-state', 'leaving');
    configuratorRoot.setAttribute('data-configurator-create-introduction', 'settled');
    if (immediate) {
      createIntroduction.hidden = true;
      createIntroduction.removeAttribute('data-state');
      return;
    }
    introductionHideTimer = window.setTimeout(function () {
      introductionHideTimer = null;
      createIntroduction.hidden = true;
      createIntroduction.removeAttribute('data-state');
    }, 460);
  }

  function completeCreateEntrance() {
    if (!entranceRunning || destroyed) return;
    entranceRunning = false;
    if (introductionFallbackTimer) window.clearTimeout(introductionFallbackTimer);
    introductionFallbackTimer = null;
    if (introductionActive) configuratorRoot.setAttribute('data-configurator-create-introduction', 'awaiting-interaction');
  }

  function beginCreateEntrance() {
    introductionDelayTimer = null;
    if (!entranceRunning || destroyed) return;
    var entranceStarted = productStage.playCreateEntrance && productStage.playCreateEntrance(function () {
      completeCreateEntrance();
    });
    if (!entranceStarted) {
      completeCreateEntrance();
      return;
    }
    if (!entranceRunning) return;
    introductionFallbackTimer = window.setTimeout(function () {
      introductionFallbackTimer = null;
      if (!entranceRunning) return;
      if (productStage.settleEntrance) productStage.settleEntrance();
      completeCreateEntrance();
    }, 3200);
  }

  function startCreateIntroduction(snapshot) {
    clearIntroductionTiming();
    introductionActive = false;
    entranceRunning = false;
    introductionDismissible = false;
    showCreateWorkspace();
    configuratorRoot.setAttribute('data-configurator-create-introduction', 'settled');
    configuratorRoot.setAttribute(
      'data-configurator-capabilities',
      shouldIntroduceCreateStage(snapshot) ? 'available' : 'dismissed'
    );
    showCreateHeading(snapshot.workflow.currentStage);
  }

  function enterCreateWorkspace() {
    if (!entryActive || destroyed) return;
    entryActive = false;
    entryDesignButton.disabled = true;
    entryDesignButton.removeEventListener('click', enterCreateWorkspace);
    if (entryEntranceTimer) window.clearTimeout(entryEntranceTimer);
    entryEntranceTimer = null;
    configuratorRoot.setAttribute('data-configurator-entry', 'entering');
    entryIntro.setAttribute('aria-hidden', 'true');
    entryIntro.setAttribute('data-state', 'leaving');
    if (productStage.settleEntrance) productStage.settleEntrance();
    entryHideTimer = window.setTimeout(function () {
      entryHideTimer = null;
      if (destroyed) return;
      entryIntro.hidden = true;
      entryIntro.removeAttribute('data-state');
      configuratorRoot.setAttribute('data-configurator-entry', 'workspace');
      showCreateWorkspace();
      startCreateIntroduction(app.getState());
      var stageTitle = workflowPanel && workflowPanel.querySelector('[data-configurator-stage-title]');
      if (stageTitle) stageTitle.focus();
    }, 260);
  }

  function handlePageHide(event) {
    if (!event.persisted) destroy();
  }

  function destroy() {
    if (destroyed) return;
    destroyed = true;
    if (unsubscribe) unsubscribe();
    if (unsubscribeArtwork) unsubscribeArtwork();
    if (entryHideTimer) window.clearTimeout(entryHideTimer);
    if (entryEntranceTimer) window.clearTimeout(entryEntranceTimer);
    if (entryDesignButton) entryDesignButton.removeEventListener('click', enterCreateWorkspace);
    clearIntroductionTiming();
    if (productStage.settleEntrance) productStage.settleEntrance();
    sampleBrowser.setActive(false);
    if (editor) editor.setActive(false);
    window.removeEventListener('pagehide', handlePageHide);
    configuratorRoot.removeAttribute('data-configurator-presentation-initialized');
    configuratorRoot.configuratorPresentation = null;
  }

  configuratorRoot.configuratorPresentation = {
    getMode: function () { return currentPresentation && currentPresentation.layout; },
    orientForSemanticInput: function (reference) {
      if (previousStageId !== 'content' || !productStage.assistView) return false;
      var side = renderedSideForSemanticReference(reference);
      return side ? productStage.assistView(side, reference) : false;
    },
    orientForLogo: function (side) {
      return (side === 'front' || side === 'back') && productStage.setView
        ? productStage.setView(side)
        : false;
    },
    destroy: destroy
  };
  unsubscribeArtwork = artworkApi.subscribe(handleArtwork);
  unsubscribe = app.subscribe(applyPresentation);
  window.addEventListener('pagehide', handlePageHide);
  var initialSnapshot = app.getState();
  configuratorRoot.setAttribute('data-configurator-capabilities', entryActive ? 'dismissed' : shouldIntroduceCreateStage(initialSnapshot) ? 'available' : 'dismissed');
  applyPresentation(initialSnapshot);
  if (entryActive) {
    setRegionActive(workflowPanel, false);
    entryDesignButton.addEventListener('click', enterCreateWorkspace);
  } else startCreateIntroduction(initialSnapshot);
}());
